import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { CVB } from 'mr-components';
import { useScreenDetector } from '../../components/custom-hooks/screen-detector';
import injectReducer from '../../utils/injectReducer';
import injectSaga from '../../utils/injectSaga';
import makeSelectCartValueBarPage from './selectors';
import reducer from './reducer';
import saga from './saga';

function CartValueBarPage(props) {
  const { offer, shopURL, cartAmount, cartQuantity } = props;
  const {
    milestones,
    theme,
    currencyFormat,
    currencySymbol,
    decimalSymbol,
    thousandSeparator,
  } = offer;
  const isMobileDevice = useScreenDetector();

  // There are 2 value types, either on price level or on quantity level
  // E.g: Price - Buy products of 100Rs and get reward
  // Quantity - Buy 2 quantities of any product and get reward
  const isPriceValueType = milestones[0].valueType === 'price';

  const getRemainingAmountRoundType = () => {
    if (
      ['adidascases.myshopify.com', 'cocovillageusa.myshopify.com'].includes(
        shopURL,
      )
    ) {
      return 'down';
    }
    return 'none';
  };

  return (
    <CVB
      currencyFormat={currencyFormat}
      currencySymbol={currencySymbol}
      decimalSymbol={decimalSymbol}
      thousandSeparator={thousandSeparator}
      milestones={milestones}
      cartAmount={isPriceValueType ? cartAmount : cartQuantity}
      // style props start
      isMobile={isMobileDevice}
      isShowHeader={theme.isCVBShowHeader}
      isShowMilestoneText={theme.isCVBShowRewards}
      isShowMilestones={theme.isCVBShowMilestones}
      offerPadding={theme.cvbWidgetPadding}
      offerMobilePadding={theme.cvbWidgetMobilePadding}
      offerMargin={theme.widgetMargin}
      offerMobileMargin={theme.widgetMobileMargin}
      offerBackgroundColor={theme.cvbOfferBackgroundColor}
      isOfferBordered={theme.isOfferBordered}
      offerBorderColor={theme.offerBorderColor}
      offerBorderWidth={theme.offerBorderWidth}
      offerBorderRadius={theme.widgetBorderRadius}
      offerHeaderText={theme.cvbOfferHeader}
      offerHeaderTextColor={theme.cvbOfferHeaderTextColor}
      offerHeaderFontSize={theme.cvbOfferHeaderSuccessFontSize}
      offerHeaderMobileFontSize={theme.cvbOfferHeaderSuccessMobileFontSize}
      offerHeaderFontWeight={theme.cvbOfferHeaderFontWeight}
      offerHeaderFontStyle={theme.cvbOfferHeaderFontStyle}
      offerHeaderTextDecoration={theme.offerHeaderTextDecoration}
      offerHeaderFontFamily={theme.offerHeaderFontFamily}
      offerHeaderTextAlignment={theme.cvbOfferHeaderTextAlignment}
      offerHeaderSuccessText={theme.cvbOfferSuccessHeader}
      offerHeaderSuccessTextColor={theme.cvbOfferHeaderTextColor}
      offerHeaderSuccessFontSize={theme.cvbOfferHeaderSuccessFontSize}
      offerHeaderSuccessMobileFontSize={
        theme.cvbOfferHeaderSuccessMobileFontSize
      }
      offerHeaderSuccessFontWeight={theme.cvbOfferHeaderSuccessFontWeight}
      offerHeaderSuccessFontStyle={theme.cvbOfferHeaderSuccessFontStyle}
      offerHeaderSuccessTextDecoration={
        theme.cvbOfferHeaderSuccessTextDecoration
      }
      offerHeaderSuccessFontFamily={theme.cvbOfferHeaderSuccessFontFamily}
      offerHeaderSuccessTextAlignment={theme.cvbOfferHeaderSuccessTextAlignment}
      offerHeaderBarBackgroundColor={theme.cvbOfferHeaderBarBackgroundColor}
      offerHeaderBarPadding={theme.cvbOfferHeaderBarPadding}
      offerHeaderBarMargin={theme.cvbOfferHeaderBarMargin}
      progressBarHeight={theme.cvbBarHeight}
      progressBarActiveColor={theme.cvbFilledColor}
      progressBarMarkerColor={theme.cvbMarkerColor}
      progressBarColor={theme.cvbTrackColor}
      progressBarBorderRadius={theme.cvbBarBorderRadius}
      milestoneValueFontSize={theme.cvbMilestoneValueFontSize}
      milestoneValueMobileFontSize={theme.cvbMilestoneValueMobileFontSize}
      milestoneValueFontStyle={theme.cvbMilestoneValueFontStyle}
      milestoneValueFontWeight={theme.cvbMilestoneValueFontWeight}
      milestoneValueTextDecoration={theme.cvbMilestoneValueTextDecoration}
      milestoneValueFontFamily={theme.cvbMilestoneValueFontFamily}
      milestoneValueTextAlignment={theme.cvbMilestoneValueTextAlignment}
      milestoneValuePadding={theme.cvbMilestoneValuePadding}
      milestoneValueMargin={theme.cvbMilestoneValueMargin}
      milestoneValueColor={theme.cvbMilestoneValueColor}
      milestoneFontSize={theme.cvbMilestoneFontSize}
      milestoneMobileFontSize={theme.cvbMilestoneMobileFontSize}
      milestoneFontStyle={theme.cvbMilestoneFontStyle}
      milestoneTextDecoration={theme.cvbMilestoneTextDecoration}
      milestoneFontWeight={theme.cvbMilestoneFontWeight}
      milestoneTextColor={theme.cvbMilestoneTextColor}
      milestoneFontFamily={theme.cvbMilestoneFontFamily}
      milestoneTextAlignment={theme.cvbMilestoneTextAlignment}
      milestonePadding={theme.cvbMilestonePadding}
      milestoneMargin={theme.cvbMilestoneMargin}
      progressBarContainerPadding={theme.cvbBarContainerPadding}
      progressBarContainerMargin={theme.cvbBarContainerMargin}
      font={theme.font}
      // style props end
      remainingAmountRoundType={getRemainingAmountRoundType()}
      mobileLayoutType={theme.cvbMobileLayoutType}
      desktopLayoutType={theme.cvbDesktopLayoutType}
      iconMobileSize={theme.cvbIconMobileSize}
      iconDesktopSize={theme.cvbIconDesktopSize}
      iconMobileBorderSize={theme.cvbIconMobileBorderSize}
      iconDesktopBorderSize={theme.cvbIconDesktopBorderSize}
      iconBorderColor={theme.cvbIconBorderColor}
      iconBorderRadius={theme.cvbIconBorderRadius}
      iconBackgroundColor={theme.cvbIconBackgroundColor}
      // cvb tiles layout props
      cvbTileTitleText={theme.cvbTileTitleText}
      cvbTileTitleTextColor={theme.cvbTileTitleTextColor}
      cvbTileTitleTextAlignment={theme.cvbTileTitleTextAlignment}
      cvbTileTitleFontFamily={theme.cvbTileTitleFontFamily}
      cvbTileTitleFontSize={
        isMobileDevice
          ? theme.cvbTileTitleMobileFontSize
          : theme.cvbTileTitleFontSize
      }
      cvbTileTitleMargin={theme.cvbTileTitleMargin}
      cvbTileTitlePadding={theme.cvbTileTitlePadding}
    />
  );
}

CartValueBarPage.propTypes = {
  offer: PropTypes.object,
  shopURL: PropTypes.string,
  cartAmount: PropTypes.number,
  cartQuantity: PropTypes.number,
};

const mapStateToProps = createStructuredSelector({
  cartValueBarPage: makeSelectCartValueBarPage(),
});

function mapDispatchToProps() {
  return {};
}
const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'cartValueBarPage', reducer });
const withSaga = injectSaga({ key: 'cartValueBarPage', saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(CartValueBarPage);
